// extracted by mini-css-extract-plugin
export default {"OneNewContent":"OneNewContent_OneNewContent__hkZZQ","OneNewContentDescr":"OneNewContent_OneNewContentDescr__UbxRu","OneNewContentDescr2":"OneNewContent_OneNewContentDescr2__qFITR"};